module.exports = __webpack_public_path__ + "static/media/2 Cuff Wrist.f2d4a6bf.jpg";